import { render, staticRenderFns } from "./d-book-user-reviews-list.vue?vue&type=template&id=0e869152&scoped=true&"
import script from "./d-book-user-reviews-list.vue?vue&type=script&lang=js&"
export * from "./d-book-user-reviews-list.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-reviews-list.vue?vue&type=style&index=0&id=0e869152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e869152",
  null
  
)

export default component.exports